import { Gift } from "lucide-react";

export const AnnouncementBar = () => (
  <div className="bg-primary text-primary-foreground py-2.5 px-4 text-center text-sm font-medium">
    <span className="inline-flex items-center gap-2">
      <Gift className="w-4 h-4 flex-shrink-0" />
      <span>
        Code <strong className="font-bold tracking-wide">FONDATEUR</strong> : -15% sur votre CynthIA
        <span className="hidden sm:inline"> </span>
      </span>
    </span>
  </div>
);
